/* 

  HEADS UP! THIS IS A GENERATED FILE!
  
  Changes done in this file will be overwritten on next generation from the code generator.

*/
import { DateRangePicker, NumberFilterInput } from 'components/filters';
import { OrganizationSelect } from 'components/Selects';
import { SecureFormsy, Select } from 'flaivy-react/components/inputs';
import RequiresRole from 'flaivy-react/components/RequiresRole';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
/* eslint-enable */
import { resolve as organizationResolve } from '../../shared/actions/generated/organization.actions';

// eslint-disable-next-line
async function resolveQuery(query) {
  const resolvedQuery = { ...query };
  // eslint-disable-next-line
  if (query.organization) {
    resolvedQuery.organization = await organizationResolve(query.organization);
  }
  return resolvedQuery;
}

const defaultActionValues = () => ({});

function ShopConfigFilterPanel({
  querySpecification,
  onChange,
  isSubForm,
  isModal,
  // eslint-disable-next-line
  immutableQuery,
}) {
  const [state, setState] = useState({
    querySpecification,
  });

  useEffect(() => {
    async function getResolvedQuery() {
      const fullyResolvedFilter = await resolveQuery(querySpecification || []);
      setState({
        querySpecification: {
          ...(querySpecification || defaultActionValues()),
        },
        resolvedQuery: {
          ...(fullyResolvedFilter || defaultActionValues()),
        },
      });
    }
    if (querySpecification) {
      getResolvedQuery();
    }
    /* eslint-disable-next-line */
  }, []);

  /* eslint-disable-next-line */
  const handleChange = async (key, value) => {
    const { querySpecification, resolvedQuery } = state;

    const newQuerySpecification = { ...querySpecification };
    const newResolvedQuery = { ...resolvedQuery };

    const isEmptyChild =
      (Array.isArray(value) && value.length === 0) ||
      (_.isObject(value) && (_.isEmpty(value) || value.iLike === '%'));

    const isEmptyValue =
      value === null ||
      value === undefined ||
      value === '' ||
      value === '<NULL>' ||
      value === '%' ||
      isEmptyChild;
    if (isEmptyValue) {
      delete newQuerySpecification[key];
      delete newResolvedQuery[key];
    } else {
      newQuerySpecification[key] = value;
      newResolvedQuery[key] = value;
    }

    setState({
      querySpecification: newQuerySpecification,
      resolvedQuery: newResolvedQuery,
    });
    // eslint-disable-next-line
    await onChange(newQuerySpecification);
  };

  const reset = async () => {
    setState({
      querySpecification: { ...immutableQuery },
      resolvedQuery: {},
    });
    // eslint-disable-next-line
    await onChange({});
  };

  /* eslint-disable no-unused-vars */
  const { resolvedQuery } = state;
  /* eslint-enable */

  return (
    <>
      <SecureFormsy isSubForm={isSubForm}>
        {!isModal && (
          <Button onClick={reset} className="my-2" color="secondary" block>
            Rensa filter
          </Button>
        )}

        {typeof immutableQuery.subdomain === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.logo === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.favicon === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.description === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.googleAnalyticsKey === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.clarityKey === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.emailFooterImage === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.address === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.zipCode === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.city === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.country === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.aboutUs === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.homePage === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.instagram === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.facebook === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.youtube === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.linkedin === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.contactEmail === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.contactPhone === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.companyName === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.organization === 'undefined' && (
          <FormGroup>
            <Label>Organisation</Label>
            <OrganizationSelect
              defaultOptions={false}
              instanceId="select-organization"
              name="organization"
              value={_.get(resolvedQuery, 'organization')}
              onChange={handleChange}
            />
          </FormGroup>
        )}

        {typeof immutableQuery.active === 'undefined' && (
          <FormGroup>
            <Label>Aktiverad</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'active') === undefined}
                onClick={() => {
                  handleChange('active', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'active') === true ||
                  _.get(resolvedQuery, 'active') === 'true'
                }
                onClick={() => {
                  handleChange('active', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'active') === false ||
                  _.get(resolvedQuery, 'active') === 'false'
                }
                onClick={() => {
                  handleChange('active', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.isSellingAlcohol === 'undefined' && (
          <FormGroup>
            <Label>Säljer alkoholhaltiga produkter</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={_.get(resolvedQuery, 'isSellingAlcohol') === undefined}
                onClick={() => {
                  handleChange('isSellingAlcohol', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isSellingAlcohol') === true ||
                  _.get(resolvedQuery, 'isSellingAlcohol') === 'true'
                }
                onClick={() => {
                  handleChange('isSellingAlcohol', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'isSellingAlcohol') === false ||
                  _.get(resolvedQuery, 'isSellingAlcohol') === 'false'
                }
                onClick={() => {
                  handleChange('isSellingAlcohol', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.usesSupplierCustomer === 'undefined' && (
          <FormGroup>
            <Label>Använder leverantörskunder</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'usesSupplierCustomer') === undefined
                }
                onClick={() => {
                  handleChange('usesSupplierCustomer', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'usesSupplierCustomer') === true ||
                  _.get(resolvedQuery, 'usesSupplierCustomer') === 'true'
                }
                onClick={() => {
                  handleChange('usesSupplierCustomer', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'usesSupplierCustomer') === false ||
                  _.get(resolvedQuery, 'usesSupplierCustomer') === 'false'
                }
                onClick={() => {
                  handleChange('usesSupplierCustomer', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.usesOrganizationProductCategories ===
          'undefined' && (
          <FormGroup>
            <Label>Använder organisations produktkategorier</Label>
            <br />
            <ButtonGroup>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'usesOrganizationProductCategories') ===
                  undefined
                }
                onClick={() => {
                  handleChange('usesOrganizationProductCategories', undefined);
                }}
              >
                Alla
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'usesOrganizationProductCategories') ===
                    true ||
                  _.get(resolvedQuery, 'usesOrganizationProductCategories') ===
                    'true'
                }
                onClick={() => {
                  handleChange('usesOrganizationProductCategories', true);
                }}
              >
                Ja
              </Button>
              <Button
                color="secondary"
                active={
                  _.get(resolvedQuery, 'usesOrganizationProductCategories') ===
                    false ||
                  _.get(resolvedQuery, 'usesOrganizationProductCategories') ===
                    'false'
                }
                onClick={() => {
                  handleChange('usesOrganizationProductCategories', false);
                }}
              >
                Nej
              </Button>
            </ButtonGroup>
          </FormGroup>
        )}

        {typeof immutableQuery.baseUrl === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.articleFilterPanelConfig === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.navbarConfig === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.cartProgressBarsColors === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.chatConfig === 'undefined' && (
          <FormGroup></FormGroup>
        )}

        {typeof immutableQuery.theme === 'undefined' && (
          <FormGroup>
            <Label>Tema</Label>
            <Select
              type="string"
              instanceId="select-theme"
              name="theme"
              value={_.get(resolvedQuery, 'theme')}
              onChange={handleChange}
              options={[
                { label: 'Flaivy - Varkala', value: 'flaivyVarkalaTheme' },
                { label: 'Privab', value: 'privabTheme' },
                { label: 'Alla', value: undefined },
              ]}
            />
          </FormGroup>
        )}

        <RequiresRole
          requiredRoles={[
            'qvantiSupplierRoleSupplierAdmin',
            'super',
            'supplier',
            'customerSubUnitAdmin',
            'customerSubUnitPurchaser',
            'customerSubUnitPurchaserManager',
            'customerSubUnitPurchaserAssociateManager',
            'customerSubUnitEconomy',
          ]}
        >
          {typeof immutableQuery.hasShopSpecificOrderRequirements ===
            'undefined' && (
            <FormGroup>
              <Label>Shoppen har egna orderkrav</Label>
              <br />
              <ButtonGroup>
                <Button
                  color="secondary"
                  active={
                    _.get(resolvedQuery, 'hasShopSpecificOrderRequirements') ===
                    undefined
                  }
                  onClick={() => {
                    handleChange('hasShopSpecificOrderRequirements', undefined);
                  }}
                >
                  Alla
                </Button>
                <Button
                  color="secondary"
                  active={
                    _.get(resolvedQuery, 'hasShopSpecificOrderRequirements') ===
                      true ||
                    _.get(resolvedQuery, 'hasShopSpecificOrderRequirements') ===
                      'true'
                  }
                  onClick={() => {
                    handleChange('hasShopSpecificOrderRequirements', true);
                  }}
                >
                  Ja
                </Button>
                <Button
                  color="secondary"
                  active={
                    _.get(resolvedQuery, 'hasShopSpecificOrderRequirements') ===
                      false ||
                    _.get(resolvedQuery, 'hasShopSpecificOrderRequirements') ===
                      'false'
                  }
                  onClick={() => {
                    handleChange('hasShopSpecificOrderRequirements', false);
                  }}
                >
                  Nej
                </Button>
              </ButtonGroup>
            </FormGroup>
          )}
        </RequiresRole>

        <RequiresRole
          requiredRoles={[
            'qvantiSupplierRoleSupplierAdmin',
            'super',
            'supplier',
            'customerSubUnitAdmin',
            'customerSubUnitPurchaser',
            'customerSubUnitPurchaserManager',
            'customerSubUnitPurchaserAssociateManager',
            'customerSubUnitEconomy',
          ]}
        >
          {typeof immutableQuery.isPossibleToPlaceOrderBelowOrderMinimum ===
            'undefined' && (
            <FormGroup>
              <Label>
                Det är möjligt att lägga order under kollikrav eller minsta
                ordervärde mot en ev.avgift.
              </Label>
              <br />
              <ButtonGroup>
                <Button
                  color="secondary"
                  active={
                    _.get(
                      resolvedQuery,
                      'isPossibleToPlaceOrderBelowOrderMinimum',
                    ) === undefined
                  }
                  onClick={() => {
                    handleChange(
                      'isPossibleToPlaceOrderBelowOrderMinimum',
                      undefined,
                    );
                  }}
                >
                  Alla
                </Button>
                <Button
                  color="secondary"
                  active={
                    _.get(
                      resolvedQuery,
                      'isPossibleToPlaceOrderBelowOrderMinimum',
                    ) === true ||
                    _.get(
                      resolvedQuery,
                      'isPossibleToPlaceOrderBelowOrderMinimum',
                    ) === 'true'
                  }
                  onClick={() => {
                    handleChange(
                      'isPossibleToPlaceOrderBelowOrderMinimum',
                      true,
                    );
                  }}
                >
                  Ja
                </Button>
                <Button
                  color="secondary"
                  active={
                    _.get(
                      resolvedQuery,
                      'isPossibleToPlaceOrderBelowOrderMinimum',
                    ) === false ||
                    _.get(
                      resolvedQuery,
                      'isPossibleToPlaceOrderBelowOrderMinimum',
                    ) === 'false'
                  }
                  onClick={() => {
                    handleChange(
                      'isPossibleToPlaceOrderBelowOrderMinimum',
                      false,
                    );
                  }}
                >
                  Nej
                </Button>
              </ButtonGroup>
            </FormGroup>
          )}
        </RequiresRole>

        <RequiresRole
          requiredRoles={[
            'qvantiSupplierRoleSupplierAdmin',
            'super',
            'supplier',
            'customerSubUnitAdmin',
            'customerSubUnitPurchaser',
            'customerSubUnitPurchaserManager',
            'customerSubUnitPurchaserAssociateManager',
            'customerSubUnitEconomy',
          ]}
        >
          {typeof immutableQuery.minOrderValueByRegion === 'undefined' && (
            <FormGroup></FormGroup>
          )}
        </RequiresRole>

        <RequiresRole
          requiredRoles={[
            'qvantiSupplierRoleSupplierAdmin',
            'super',
            'supplier',
            'customerSubUnitAdmin',
            'customerSubUnitPurchaser',
            'customerSubUnitPurchaserManager',
            'customerSubUnitPurchaserAssociateManager',
            'customerSubUnitEconomy',
          ]}
        >
          {typeof immutableQuery.minCollisOnOrderByRegion === 'undefined' && (
            <FormGroup></FormGroup>
          )}
        </RequiresRole>

        <RequiresRole
          requiredRoles={[
            'qvantiSupplierRoleSupplierAdmin',
            'super',
            'supplier',
            'customerSubUnitAdmin',
            'customerSubUnitPurchaser',
            'customerSubUnitPurchaserManager',
            'customerSubUnitPurchaserAssociateManager',
            'customerSubUnitEconomy',
          ]}
        >
          {typeof immutableQuery.kegCountsAsNCollis === 'undefined' && (
            <FormGroup>
              <Label>Hur många kollin varje fat räknas som på en order</Label>
              <NumberFilterInput
                name="kegCountsAsNCollis"
                value={_.get(resolvedQuery, 'kegCountsAsNCollis')}
                onChange={handleChange}
              />
            </FormGroup>
          )}
        </RequiresRole>

        {typeof immutableQuery.files === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.pages === 'undefined' && <FormGroup></FormGroup>}

        {typeof immutableQuery.createdAt === 'undefined' && (
          <FormGroup>
            <Label>Skapad</Label>
            <DateRangePicker
              name="createdAt"
              value={_.get(resolvedQuery, 'createdAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
        {typeof immutableQuery.updatedAt === 'undefined' && (
          <FormGroup>
            <Label>Uppdaterad</Label>
            <DateRangePicker
              name="updatedAt"
              value={_.get(resolvedQuery, 'updatedAt')}
              onChange={handleChange}
            />
          </FormGroup>
        )}
      </SecureFormsy>
      {isModal && (
        <Button onClick={reset} className="mt-3">
          Rensa filter
        </Button>
      )}
    </>
  );
}

ShopConfigFilterPanel.propTypes = {
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  isSubForm: PropTypes.bool,
  isModal: PropTypes.bool,
};

ShopConfigFilterPanel.defaultProps = {
  querySpecification: defaultActionValues(),
  immutableQuery: {},
  isSubForm: false,
  isModal: false,
};

function ShopConfigFilterPanelModal({
  onSubmit,
  querySpecification,
  immutableQuery,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const handleChange = newQuerySpecification => {
    onSubmit(newQuerySpecification);
  };

  const applyFilters = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal toggle={toggle} isOpen={isOpen} centered scrollable>
        <ModalHeader toggle={toggle}>Filtrera</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <ShopConfigFilterPanel
                onChange={handleChange}
                querySpecification={querySpecification}
                immutableQuery={immutableQuery}
                isModal
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Row>
            <Col>
              <Button
                onClick={applyFilters}
                color="primary"
                className="float-end mt-3"
              >
                Stäng
              </Button>
            </Col>
          </Row>
        </ModalFooter>
      </Modal>
      <Button color="outline-secondary" onClick={toggle}>
        Filtrera
      </Button>
    </>
  );
}

ShopConfigFilterPanelModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  querySpecification: PropTypes.object,
  immutableQuery: PropTypes.object,
};

ShopConfigFilterPanelModal.defaultProps = {
  querySpecification: null,
  immutableQuery: {},
};

module.exports = { ShopConfigFilterPanel, ShopConfigFilterPanelModal };
